import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ControlType, SearchControl } from 'bpt-ui-library/bpt-search';
import { Observable, catchError, forkJoin, of, finalize, map } from 'rxjs';
import { CourseCatalogueConstants } from '../course-catalogue-constants';
import { UsersService } from '../../shared/services/users.service';
import { CourseService } from '../../course/services/course.service';
import { CourseCatalogueSearch } from '../models/course-catalogue-search';
import { CourseCatalogueSearchResult } from '../models/course-catalogue-search-result';
import { CourseCatalogueService } from '../services/course-catalogue.service';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { MessageService } from 'primeng/api';
import { PanelHubComponent } from '../../shared-components/panel-hub/panel-hub.component';
import { PanelHubConfiguration } from '../../shared-components/panel-hub/models/panel-hub-configuration';
import { QueryResult } from '../../shared-components/panel-hub/models/query-result';
import { PanelHubStateChangedEvent } from '../../shared-components/panel-hub/models/panel-hub-state-changed-event';
import { PanelHubEventType } from '../../shared-components/panel-hub/enums/panel-hub-eventtype';
import { Features } from '../../shared-components/panel-hub/enums/features.enum';
import { PaginationConfigByFeature } from '../../shared-components/panel-hub/constants/feature-pagination-configuration';
import { PanelHubConstants } from '../../shared-components/panel-hub/constants/panel-hub-constants';
import { PanelView } from '../../shared-components/panel-hub/enums/panel-view.enum';
import { PaginationState } from '../../shared-components/panel-hub/models/pagination-state';
import { AppliedFilters } from '../../shared-components/panel-hub/models/applied-filters';
import { SortCriteria } from '../../shared-components/panel-hub/models/sort-criteria';
import { FilterConfig } from '../../shared-components/panel-hub/models/filter-config';
import { FilterCriteria } from '../../shared-components/panel-hub/models/filter-criteria';
import { SortField } from '../../shared-components/panel-hub/models/sort-field';
import { PanelEventHub } from '../../shared-components/panel-hub/models/panel-event-hub';
import { toOptions, toOptionsWithSort } from '../../shared/utils';
import { TrainingItemGroupSearchCriteria } from '../../training-item-group-search/models/training-item-group-search-criteria';
import { TrainingItemGroupService } from '../../training-item/services/training-item-group.service';
import { IEQMSScopeLookUpDetails } from '../../shared/models/scopes/eqms-Scope-lookup-details';
import { CourseConstants } from '../../course/constants/course.constants';
import { AssignmentGroupService } from '../../system-admin/assignment-group/services/assignment-group.service';

@Component({
  selector: 'app-course-catalogue-search',
  templateUrl: './course-catalogue-search.component.html',
  styleUrls: ['./course-catalogue-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CourseCatalogueSearchComponent implements OnInit, AfterViewInit {
  @Input() feature: string = CourseCatalogueConstants.Course_Feature;
  @Input() panelListScreen!: string;
  @Output() emitSelectedData = new EventEmitter();
  @Output() shouldAddTrainingItemAsCourseButtonDisplayed = new EventEmitter();
  @Input() enableCheckBoxes: boolean = false;
  @Input() enableToaster: boolean = true;

  courseCatalogueSearchResult: CourseCatalogueSearchResult[] = [];
  isSearch = false;
  placeHolder: string = CourseCatalogueConstants.CourseSearch_Place_Holder_Text;
  filterData: any[] = [];
  courseMasterData: any = {};
  scopeList: any = [];
  userList: any = [];
  courseCatalogueSearchData: CourseCatalogueSearch = new CourseCatalogueSearch();
  displayDataCollected: any;
  spinnerOn: boolean = false;
  currentView: PanelView = PanelView.Default;

  // Pagination-related properties
  panelEventHub!: PanelEventHub;
  panelHubConfig: PanelHubConfiguration = {
    title: "",
    feature: Features.CourseCatalogueView,
    standardFilterCount: PanelHubConstants.StandardFilterLength,
    showSelectAll: false,
    enableShowAllToggle: false,
    enableSelectAll: false,
    enableSelection: false,
    enableToggling: true,
    enablePanelCardClick: false,
    enablePanelHighLight: false,
    enablePanelCardView: false,
    enableExpandCollapse: true,
    enableViewModes: true,
    enableAssignmentView: false,
    enableWhereAmIUsedView: true,
    paginationConfig: PaginationConfigByFeature[Features.CourseCatalogueView],
    selectionIdField: 'courseId',
  };

  pagedData: QueryResult = { totalRecords: 0, data: [], pageNumber: 1, pageSize: 0 };
  currentFilters: AppliedFilters | null = null;
  currentPagination: PaginationState | null = null;
  currentSort: SortCriteria | null = null;
  isPanelHubDataAvailable: boolean = false;
  noData: boolean = false;
  
  // Flag to track if user has initiated a search
  hasUserSearched: boolean = false;
  // Base filters from main search (bpt-search) - preserved across view changes and filter resets
  baseFilters: AppliedFilters | null = null;
  // Primary search text from bpt-search component
  primarySearchText: string | null = null;
  // Secondary search text from panel-hub (min 3 chars)
  secondarySearchText: string | null = null;

  // Selection state tracking for bulk operations (from panel-hub)
  selectAllActive: boolean = false;
  selectedCourseIds: Set<string> = new Set();
  deselectedCourseIds: Set<string> = new Set();

  // Master data for filters
  masterFilterData: any = {};
  isMasterDataLoaded = false;

  searchControl: SearchControl[] = [];

  @ViewChild(PanelHubComponent)
  private panelHub!: PanelHubComponent;

  constructor(
    private courseCatalogueService: CourseCatalogueService,
    private courseService: CourseService,
    private eqmsScopeManagementService: EqmsScopeManagementService,
    private usersService: UsersService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
    private trainingItemGroupService: TrainingItemGroupService,
    private assignmentGroupService: AssignmentGroupService
  ) { }

  ngOnInit(): void {
    this.initializePanelHubConfig();
    this.initializePanelHub();
    this.currentPagination = {
      pageNumber: this.panelHubConfig.paginationConfig.startPage,
      pageSize: this.panelHubConfig.paginationConfig.defaultPageSize,
      totalRecords: 0
    };
  }

  ngAfterViewInit(): void {
    // Additional initialization if needed
  }

  onPanelEventHubInitialized(event: PanelEventHub) {
    this.panelEventHub = event;
  }

  private initializePanelHubConfig() {
    this.panelHubConfig.enableSelection = this.enableCheckBoxes;
    this.panelHubConfig.showSelectAll = this.enableCheckBoxes;
    this.panelHubConfig.enableSelectAll = this.enableCheckBoxes;
  }

  private initializePanelHub() {
    this.spinnerOn = true;
    
    forkJoin(this.fetchLookupSources()).subscribe({
      next: (results) => {
        const users = results.users as any[];
        const scopeLookup = results.scopeLookup as any[];
        const courseMasterData = results.courseMasterData as any;

        const scopeIdsAsNumbers = scopeLookup.map((scope: IEQMSScopeLookUpDetails) => scope.eQMSScopeId);
        const trainingItemGroupSearchCriteria: TrainingItemGroupSearchCriteria = { eQMSScopes: scopeIdsAsNumbers };
        const assignmentTypes = [
          CourseConstants.AssignmentGroup_CourseOwnerAssignment,
        CourseConstants.AssignmentGroup_QualifiedTrainerAssignment];
        let assignmentGroupsRequest = {
          scopes: scopeIdsAsNumbers.map(id=>id.toString()),
          assignmentTypes: assignmentTypes
        };

        forkJoin({
          assignmentGroups: this.assignmentGroupService.getActiveAndInActiveAssignmentGroups(assignmentGroupsRequest).pipe(catchError(() => of([]))),
          trainingItemGroups: this.trainingItemGroupService.searchTrainingItemGroups(trainingItemGroupSearchCriteria).pipe(catchError(() => of({ records: [] }))),
        }).subscribe({
          next: ({assignmentGroups, trainingItemGroups}) => {
            const assignmentGroupsArray = Array.isArray(assignmentGroups) ? assignmentGroups : [];
            const trainingItemGroupRecords = trainingItemGroups?.records ?? [];
            this.buildSearchControls(users, scopeLookup, courseMasterData);
            this.buildMasterFilterData(users, scopeLookup, courseMasterData, trainingItemGroupRecords, assignmentGroupsArray);
            this.spinnerOn = false;
              this.isMasterDataLoaded = true;
        const filterConfigs = this.getFilterConfigsForView(this.currentView);
        const sortOptions = this.getSortOptionsForView(this.currentView);
        this.setPanelHubConfigExtensions(filterConfigs, sortOptions);}, 
        error: (err) => {
          this.buildSearchControls(users, scopeLookup, courseMasterData);
            this.buildMasterFilterData(users, scopeLookup, courseMasterData, [], []);
          this.spinnerOn = false;
          this.isMasterDataLoaded = true;
            this.handleInitError();}
      });
      }
    })
  }

  private fetchLookupSources() {
    return {
      users: this.usersService.getUsers(),
      scopeLookup: this.courseCatalogueService.geteQMSScopesForCourseSearch(this.feature),
      courseMasterData: this.courseService.getCourseDetails(),
    };
  }

  private buildSearchControls(users: any[], scopeLookup: any[], courseMasterData: any, assignmentGroups: any[] = []) {
    let activeQualifiedTrainerAssignmentGroups = assignmentGroups?.filter(ag => ag.assignmentType === CourseConstants.AssignmentGroup_QualifiedTrainerAssignment && ag.isActive);
    let activeOwnerAssignmentGroups = assignmentGroups?.filter(ag => ag.assignmentType === CourseConstants.AssignmentGroup_CourseOwnerAssignment && ag.isActive);
    this.userList = users.map(user => ({ value: user.name, name: user.name }));
    this.scopeList = scopeLookup.map(scope => ({ value: scope.eQMSScopeId, name: scope.eQMSScopeName }));
    this.courseMasterData = courseMasterData;

    let ownersList = this.userList.concat(
      activeOwnerAssignmentGroups
        .map(ag => ({ value: ag.name, name: ag.name })));
    let qualifiedTrainerList = this.userList.concat(
      activeQualifiedTrainerAssignmentGroups.map(ag => ({ value: ag.name, name: ag.name }))
    )

    this.searchControl = [
      {
        controlType: ControlType.List,
        label: 'eQMS Scope(s)',
        fieldName: 'eQMSScope',
        multiSelect: true,
        options: this.scopeList,
        value: undefined,
        labelField: 'name',
        valueField: 'value',
        showFilter: true,
        order: 1,
      },
      {
        controlType: ControlType.List,
        label: 'Owner(s)',
        fieldName: 'owner',
        multiSelect: true,
        options: ownersList,
        value: undefined,
        labelField: 'name',
        valueField: 'value',
        showFilter: true,
        order: 2,
      },
      {
        controlType: ControlType.List,
        label: 'Qualified Trainer(s)',
        fieldName: 'qualifiedTrainer',
        multiSelect: true,
        options: qualifiedTrainerList,
        value: undefined,
        labelField: 'name',
        valueField: 'value',
        showFilter: true,
        order: 3,
      },
      {
        controlType: ControlType.List,
        label: 'Status',
        fieldName: 'status',
        options: courseMasterData.statuses,
        multiSelect: true,
        value: [0],
        labelField: 'name',
        valueField: 'value',
        showFilter: true,
        order: 4
      },
      {
        controlType: ControlType.List,
        label: 'Format',
        fieldName: 'format',
        options: courseMasterData.formats,
        multiSelect: true,
        value: undefined,
        labelField: 'name',
        valueField: 'value',
        showFilter: true,
        order: 5,
      }
    ];
  }

  private buildMasterFilterData(users: any[], scopeLookup: any[], courseMasterData: any, trainingItemGroups: any[], assignmentGroups: any[]) {
    const trainingItemGroupsList = trainingItemGroups
      .filter((tig: any) => tig.name)
      .map((tig: any) => ({ name: tig.name, value: tig.number }))
      .sort((a: any, b: any) => a.name.localeCompare(b.name));

      let ownerAssignmentGroups = assignmentGroups?.filter(ag => ag.assignment === CourseConstants.AssignmentGroup_CourseOwnerAssignment);
      let ownerAssignmentGroupOptions = [...toOptionsWithSort(ownerAssignmentGroups, 'name', 'name')];
      let allOwners = [...toOptionsWithSort(users, 'name', 'name')].concat(ownerAssignmentGroupOptions);

    this.masterFilterData = {
      users: allOwners,
      eqmsScopeList: [...toOptionsWithSort(scopeLookup, 'eQMSScopeName', 'eQMSScopeId')],
      statuses: [...toOptions(courseMasterData.statuses, 'name', 'value')],
      formats: [...toOptions(courseMasterData.formats, 'name', 'value')],
      trainingItemGroups: trainingItemGroupsList,
    };
  }

  private setPanelHubConfigExtensions(filterConfigs: FilterConfig[], sortOptions: SortField[]) {
    this.panelHubConfig = { ...this.panelHubConfig, filterConfigs, sortOptions };
  }

  // Search Methods
  getAdvancedSearchResults = (filters: Array<any>, searchText: string): Observable<number> => {
    this.filterData = filters;
    this.resetCourseSearchData();
    this.resetPanelHubState();
    
    // Reset pagination to first page for new search
    if (this.currentPagination) {
      this.currentPagination.pageNumber = 1;
    }
    
    this.primarySearchText = (searchText !== null && searchText !== undefined) ? searchText : null;
    this.courseCatalogueSearchData.searchText = this.primarySearchText ?? undefined;
    
    // Store base filters from main search
    this.buildBaseFilters(filters);
    
    filters.forEach(filterControl => {
      switch (filterControl.columnName) {
        case "owner":
          this.courseCatalogueSearchData.owners = filterControl.values;
          break;
        case "qualifiedTrainer":
          this.courseCatalogueSearchData.qualifiedTrainers = filterControl.values;
          break;
        case "eQMSScope":
          this.courseCatalogueSearchData.eQMSScopes = filterControl.values;
          break;
        case "status":
          this.courseCatalogueSearchData.status = filterControl.values.map(String);
          break;
        case "format": 
          if (filterControl.values !== undefined) {
            this.courseCatalogueSearchData.format = filterControl.values.map(String);
          }          
          break;
      }
    });

    const isAllValuesEmpty = this.areAllValuesNullOrUndefined(this.courseCatalogueSearchData);  

    if (isAllValuesEmpty) {
      if (this.enableToaster) {
        this.messageService.add({
          severity: CourseCatalogueConstants.Severity_Info,
          summary: CourseCatalogueConstants.CourseSearchEmpty_Filters,
        });
      }
      return of(0);
    }

    this.hasUserSearched = true;
    this.updatePanelHubConfigForCurrentView();
    return of(this.performCourseSearch());
  };

  getSearchResults = (searchText: string): Observable<number> => {
    this.resetCourseSearchData();
    
    this.resetPanelHubState();
    
    this.primarySearchText = (searchText !== null && searchText !== undefined) ? searchText : null;
    this.courseCatalogueSearchData.searchText = this.primarySearchText ?? undefined;

    this.secondarySearchText = null;
    this.filterData = [];

    this.baseFilters = null;
    
    this.hasUserSearched = true;
    this.updatePanelHubConfigForCurrentView();
    return of(this.performCourseSearch());
  };

  private buildBaseFilters(filters: Array<any>) {
    if (!filters || filters.length === 0) {
      this.baseFilters = null;
      return;
    }

    const filterCriteria: FilterCriteria[] = filters
      .filter(filter => filter.values !== undefined && filter.values !== null) // Only include filters with actual values
      .map(filter => ({
        field: this.mapFieldName(filter.columnName),
        values: Array.isArray(filter.values) ? filter.values : [filter.values]
      }))
      .filter(fc => fc.values.length > 0); // Exclude empty arrays

    // If no valid filters remain, set baseFilters to null
    if (filterCriteria.length === 0) {
      this.baseFilters = null;
      return;
    }

    this.baseFilters = {
      filters: filterCriteria,
      searchText: undefined // Don't include searchText here as it's already in courseCatalogueSearchData
    };
  }

  private mapFieldName(columnName: string): string {
    switch (columnName) {
      case "owner": return "owners";
      case "qualifiedTrainer": return "qualifiedTrainers";
      case "eQMSScope": return "eQMSScopeDisplayNames";
      case "status": return "statusName";
      case "format": return "formatName";
      default: return columnName;
    }
  }

  private areAllValuesNullOrUndefined(data: any): boolean {
    return Object.entries(data).every(([key, value]) => {
      if (key === CourseCatalogueConstants.Course_Search_Text) {
        return typeof value === 'string' && value.trim() === '';
      }
      if (key === CourseCatalogueConstants.Course_Search_Status_Text) {
        return Array.isArray(value) && value.length === 0;
      }
      if (key === CourseCatalogueConstants.Course_Search_Format_Text) {
        return Array.isArray(value) && value.length === 0 || value === undefined;
      }
      return value === undefined;
    });
  }

  private performCourseSearch(): number {

    // Ensure pagination is initialized
    if (!this.currentPagination) {
      this.currentPagination = {
        pageNumber: this.panelHubConfig.paginationConfig.startPage,
        pageSize: this.panelHubConfig.paginationConfig.defaultPageSize,
        totalRecords: 0
      };
    }
     
    this.panelEventHub?.startLoader();

    this.courseCatalogueService.getCourseCatalogueSearch(
      this.courseCatalogueSearchData,
      this.currentPagination,
      this.currentFilters,
      this.currentSort
    ).pipe(
      map(result => ({ result })),
      catchError(err => {
        this.pagedData = { totalRecords: 0, data: [], pageNumber: 1, pageSize: 0 };
        this.noData = true;
        if (this.enableToaster) {
          this.messageService.add({
            severity: CourseCatalogueConstants.Severity_Err,
            summary: CourseCatalogueConstants.CourseSearch_Error_Message,
            sticky: true
          });
        }
        return of(null);
      }),
      finalize(() => {
        this.panelEventHub?.stopLoader();
        this.spinnerOn = false;
      })
    ).subscribe(res => {
      if (!res) return;
      this.updateeQMSScopeData(res.result.data, res.result.totalRecords);
    });

    this.isSearch = true;
    return 0;
  }

  private refreshPanelHubData() {
    if (!this.currentPagination) {
      this.currentPagination = {
        pageNumber: this.panelHubConfig.paginationConfig.startPage,
        pageSize: this.panelHubConfig.paginationConfig.defaultPageSize,
        totalRecords: 0
      };
    }
    this.performCourseSearch();
  }

  // Panel Hub Event Handling
  onPanelHubEvent(event: PanelHubStateChangedEvent) {
    if(!this.hasUserSearched) return;
    switch (event.type) {
      case PanelHubEventType.FilterChanged:
        const panelHubFilters = event.state.filters || null;
        this.secondarySearchText = panelHubFilters?.searchText || null;
        this.currentFilters = panelHubFilters;
        this.clearSelections();
        this.refreshPanelHubData();
        break;
      case PanelHubEventType.SortChanged:
        this.currentSort = event.state.sort || null;
        this.refreshPanelHubData();
        break;
      case PanelHubEventType.PaginationChanged:
        this.currentPagination = event.state.pagination || null;
        this.clearSelections();
        this.refreshPanelHubData();
        break;
      case PanelHubEventType.SelectAllToggled:
      case PanelHubEventType.ItemSelectionChanged:
        this.handleSelectionChange(event);
        break;
    }
  }

  // View Management
  onViewChanged(view: PanelView) {
    this.currentView = view;
    this.cdr.detectChanges();
    this.updateDataForView(view);
    this.updateConfigurationForView(view);
  }

  private updateDataForView(view: PanelView) {
    this.currentView = view;
    
    if (this.currentPagination) {
      this.currentPagination.pageNumber = 1;
    }
    
    if (this.hasUserSearched) {
      this.refreshPanelHubData();
    }
  }

  private updateConfigurationForView(view: PanelView) {
    const filterConfigs = this.getFilterConfigsForView(view);
    const sortOptions = this.getSortOptionsForView(view);
    this.panelHubConfig = { ...this.panelHubConfig, filterConfigs, sortOptions };
    this.resetPanelConfiguration();
    this.refreshPanelHubData();
  }

  private updatePanelHubConfigForCurrentView() {
    const filterConfigs = this.getFilterConfigsForView(this.currentView);
    const sortOptions = this.getSortOptionsForView(this.currentView);
    this.panelHubConfig = { ...this.panelHubConfig, filterConfigs, sortOptions };
  }

  // Filter and Sort Configuration
  private getFilterConfigsForView(view: PanelView): FilterConfig[] {
    switch (view) {
      case PanelView.WhereAmIUsed:
        return this.buildFilterConfigsForWhereAmIUsedView();
      case PanelView.Default:
      default:
        return this.buildFilterConfigs();
    }
  }

  private getSortOptionsForView(view: PanelView): SortField[] {
    switch (view) {
      case PanelView.WhereAmIUsed:
        return this.buildSortOptionsForWhereAmIUsedView();
      case PanelView.Default:
      default:
        return this.buildSortOptions();
    }
  }

  private buildFilterConfigs(): FilterConfig[] {
    return [
      { displayName: 'Status', fieldName: 'statusName', options: this.masterFilterData?.statuses || [] },
      { displayName: 'Format', fieldName: 'formatName', options: this.masterFilterData?.formats || [] },
      { displayName: 'Owner(s)', fieldName: 'owners', options: this.masterFilterData?.users || [] },
      { displayName: 'eQMS Scope(s)', fieldName: 'eQMSScopeDisplayNames', options: this.masterFilterData?.eqmsScopeList || [] }
    ].filter(fc => fc.options && fc.options.length > 0);
  }

  private buildSortOptions(): SortField[] {
    return [
      { fieldDisplayName: 'Status', fieldName: 'status' },
      { fieldDisplayName: 'Format', fieldName: 'format' },
      { fieldDisplayName: 'Owner(s)', fieldName: 'owners' },
      { fieldDisplayName: 'eQMS Scope(s)', fieldName: 'eQMSScopeDisplayNames' }
    ];
  }

  private buildFilterConfigsForWhereAmIUsedView(): FilterConfig[] {
    return [
      { displayName: 'eQMS Scope(s)', fieldName: 'eQMSScopeDisplayNames', options: this.masterFilterData?.eqmsScopeList || [] },
      { displayName: 'Curriculum(s)', fieldName: 'curriculums', options: this.masterFilterData?.eqmsScopeList || [] },
      { displayName: 'Training Item Group(s)', fieldName: 'trainingitemgroups', options: this.masterFilterData?.trainingItemGroups || [] }
    ].filter(fc => fc.options && fc.options.length > 0);
  }

  private buildSortOptionsForWhereAmIUsedView(): SortField[] {
    return [
      { fieldDisplayName: 'eQMS Scope(s)', fieldName: 'eQMSScopeDisplayNames' },
      { fieldDisplayName: 'Curriculum(s)', fieldName: 'curriculums' },
      { fieldDisplayName: 'Training Item Group(s)', fieldName: 'trainingitemgroups' }
    ];
  }

  // Data Processing
  private updateeQMSScopeData(records: any[], totalRecordCount: number) {
    this.eqmsScopeManagementService.geteQMSScopeLookup().subscribe((eQMSScopes) => {
      records.forEach((courseDetail) => {
        courseDetail.eQMSScopeDisplayNames = [];
        if (courseDetail.eqmsScopes && Array.isArray(courseDetail.eqmsScopes)) {
          courseDetail.eqmsScopes.forEach((eQMSScopeData: number) => {
            const eQMSScope = eQMSScopes.filter((e: { eQMSScopeId: number; }) => e.eQMSScopeId === eQMSScopeData);
            if (eQMSScope.length > 0) {
              courseDetail.eQMSScopeDisplayNames = courseDetail.eQMSScopeDisplayNames || [];
              courseDetail.eQMSScopeDisplayNames.push(eQMSScope[0].eQMSScopeName);
            }
          });
        }
      });

      this.updateSearchResult(records, totalRecordCount);
    });
  }

  private updateSearchResult(records: any[], totalRecordCount: number) {
    const processed = this.transformCourses(records);
    this.courseCatalogueSearchResult = processed;
    this.pagedData = {
      data: processed,
      totalRecords: totalRecordCount,
      pageNumber: this.currentPagination?.pageNumber ?? 1,
      pageSize: this.currentPagination?.pageSize ?? this.panelHubConfig.paginationConfig.defaultPageSize
    };
    if (this.currentPagination) {
      this.currentPagination.totalRecords = totalRecordCount;
    }
    
    this.noData = processed.length === 0;
    this.isPanelHubDataAvailable = true;
    this.setButtonOnSearchRecordCount(totalRecordCount);
    this.spinnerOn = false;
  }

  private transformCourses(list: CourseCatalogueSearchResult[] | null | undefined): CourseCatalogueSearchResult[] {
    if (!Array.isArray(list) || list.length === 0) return [];
    return list.map(course => this.enrichCourse(course));
  }

  private enrichCourse(course: CourseCatalogueSearchResult): CourseCatalogueSearchResult {
    // Add any enrichment logic here
    return course;
  }

  private setButtonOnSearchRecordCount(searchRecordsCount: number) {
    this.shouldAddTrainingItemAsCourseButtonDisplayed.emit(searchRecordsCount > 0);
  }

  // Utility Methods
  resetPanelConfiguration() {
    this.currentPagination = {
      pageNumber: this.panelHubConfig.paginationConfig.startPage,
      pageSize: this.panelHubConfig.paginationConfig.defaultPageSize,
      totalRecords: 0
    };
    this.currentFilters = this.baseFilters ? { ...this.baseFilters } : null;
    this.currentSort = null;
    this.secondarySearchText = null;
    if (this.panelEventHub) {
      this.panelEventHub.resetConfigurations();
    }
  }

  private resetCourseSearchData() {
    this.courseCatalogueSearchData.eQMSScopes = undefined;
    this.courseCatalogueSearchData.owners = undefined;
    this.courseCatalogueSearchData.qualifiedTrainers = undefined;
    this.courseCatalogueSearchData.status = undefined;
    this.courseCatalogueSearchData.format = undefined;
    this.courseCatalogueSearchData.searchText = undefined;
  }


  private resetPanelHubState(): void {
    if (this.panelEventHub?.resetConfigurations) {
      this.panelEventHub.resetConfigurations();
    }
    this.currentFilters = null;
    this.currentSort = null;
    this.secondarySearchText = null;
    
    if (this.currentPagination) {
      this.currentPagination.pageNumber = 1;
    }
  }

  private handleInitError() {
    this.isPanelHubDataAvailable = false;
    this.spinnerOn = false;
    this.pagedData = { totalRecords: 0, data: [], pageNumber: 1, pageSize: 0 };
    this.noData = true;
    if (this.enableToaster) {
      this.messageService.add({
        severity: CourseCatalogueConstants.Severity_Err,
        summary: CourseCatalogueConstants.CourseSearch_Error_Message,
        sticky: true
      });
    }
  }

  linkedItemsSelectedData(event: any) {
    this.displayDataCollected = event;
    this.emitSelectedData.emit(this.displayDataCollected);  
  }

  calculatePhaseColor = (phase: number): string => {
    let statusColor = '';
    switch (phase) {
      case 0:
        statusColor = 'active';
        break;
      case 1:
        statusColor = 'in_active';
        break;
    }
    return statusColor;
  };

  openCourse(courseNumber: string) {
    const url = location.origin.concat("/training/eqms.courses/", courseNumber);
    window.open(url, "_blank");
  }

  openCurriculum(curriculumScopeId: number) {
    const url = location.origin.concat(`/eqms.curriculum/curriculumLinkout?scopeId=${curriculumScopeId}&&isLinkout=true`);
    window.open(url, "_blank");
  }  

  openTrainingItemGroup(trainingItemGroupNumber: string) {
    const url = location.origin.concat(`/eqms.training-item/trainingItemGroupLinkout?trainingItemGroupNumber=${trainingItemGroupNumber}&&isLinkout=true`);
    window.open(url, "_blank");
  }

  handleSelectionChange(event: PanelHubStateChangedEvent) {
    const selectedItemIds = event.state.selectedItems || [];
    const deselectedItemIds = event.state.deselectedItems || [];
    const isSelectAllActive = event.state.isSelectAllAcrossPages || false;

    // Update selection state for bulk operations - no need to emit, template checks selectedCourseIds.size directly
    this.selectAllActive = isSelectAllActive;
    this.selectedCourseIds = new Set(selectedItemIds);
    this.deselectedCourseIds = new Set(deselectedItemIds);

    // Emit the actual selected CourseCatalogueSearchResult objects for components that use this library search
    this.emitSelectedCourses();
  }

  private emitSelectedCourses(): void {
    const selectedCourses: CourseCatalogueSearchResult[] = [];

    if (this.pagedData?.data && Array.isArray(this.pagedData.data)) {
      this.pagedData.data.forEach((course: CourseCatalogueSearchResult) => {
        const courseId = (course as any)['courseId'];
        
        if (this.selectAllActive && !this.deselectedCourseIds.has(courseId)) {    
            selectedCourses.push(course);         
        } else if (this.selectedCourseIds.has(courseId)) {
            selectedCourses.push(course);
          }
      });
    }

    // Emit the selected courses
    this.displayDataCollected = selectedCourses;
    this.emitSelectedData.emit(selectedCourses);
  }

  private clearSelections(): void {
    // Clear all selection states
    this.selectAllActive = false;
    this.selectedCourseIds = new Set();
    this.deselectedCourseIds = new Set();
    
    // Clear selection in the panel hub component
    this.panelHub?.clearSelection();
    
    // Emit empty selection
    this.displayDataCollected = [];
    this.emitSelectedData.emit([]);
  }

  public clearSelectionsAfterBulkOperation(): void {
    // Clear all selections after bulk operations
    this.panelHub.clearSelection();
  }
}
